const getCSRFToken = (): string =>
  document.querySelector("meta[name='csrf-token']")?.getAttribute('content') ||
  '';

export const csrfHeader = () => ({ 'X-CSRF-Token': getCSRFToken() });
